// extracted by mini-css-extract-plugin
export default {"wrapper":"VerticalTabs_wrapper__hF63z","content":"VerticalTabs_content__IOUIS"};